import {
  createComponentClickedEvent,
  createErrorEvent,
  createScreenViewedEvent,
  createSubmittedEvent,
  track,
} from "./base"
import { type RehabSowTabs } from "@/screens/rehab/RehabSowScreen"

/**
 * Tracks when the Rehab SOW screen is viewed.
 */
export const rehabSOWViewed = ({
  propertyAddress,
}: {
  propertyAddress: string
}) => {
  track(
    createScreenViewedEvent({
      current_screen: "Rehab SOW",
      property_address: propertyAddress,
    })
  )
}

/**
 * Tracks when a user selects a tab in the Rehab SOW screen.
 */
export const rehabSOWTabSelected = ({
  propertyAddress,
  selectedTab,
}: {
  propertyAddress: string
  selectedTab: RehabSowTabs
}) => {
  track(
    createComponentClickedEvent({
      current_screen: "Rehab SOW",
      component_type: "button",
      component_function: "switch rehab SOW tab",
      component_text: selectedTab,
      clicked_values: {
        property_address: propertyAddress,
        selected_tab: selectedTab,
      },
    })
  )
}

/**
 * Tracks when a Rehab Category is viewed.
 */
export const rehabCategoryViewed = ({
  propertyAddress,
  category,
}: {
  propertyAddress: string
  category: string
}) => {
  track(
    createScreenViewedEvent({
      current_screen: "Rehab Category",
      from_screen: "Rehab SOW",
      property_address: propertyAddress,
      viewed_values: {
        category,
      },
    })
  )
}

/**
 * Tracks when a user selects a rehab category option.
 */
export const rehabCategoryOptionClicked = ({
  propertyAddress,
  category,
  option,
}: {
  propertyAddress: string
  category: string
  option: string
}) => {
  track(
    createComponentClickedEvent({
      current_screen: "Rehab Category",
      component_type: "button",
      component_function: "select rehab category option",
      component_text: option,
      clicked_values: {
        property_address: propertyAddress,
        category,
        option,
      },
    })
  )
}

/**
 * Tracks when a rehab SOW is successfully submitted.
 */
export const rehabSOWSubmitted = ({
  propertyAddress,
  rehabBudget,
  selectedCategories,
  additionalInfo,
}: {
  propertyAddress: string
  rehabBudget: number
  selectedCategories: string[]
  additionalInfo?: string
}) => {
  track(
    createSubmittedEvent({
      object_name: "Rehab Scope of Work",
      current_screen: "Rehab SOW",
      to_screen: "Loans",
      component_type: "button",
      component_text: "Submit Rehab Budget",
      submitted_values: {
        component_function: "rehab budget submitted",
        property_address: propertyAddress,
        rehab_budget: rehabBudget,
        selected_categories: selectedCategories,
        additional_info: additionalInfo,
      },
    })
  )
}

/**
 * Tracks an error when submitting a Rehab SOW.
 */
export const rehabSOWErrorEncountered = ({
  error,
  displayedMessage,
  propertyAddress,
}: {
  error: Error
  displayedMessage: string
  propertyAddress: string
}) => {
  track(
    createErrorEvent({
      event_name: "Rehab SOW Submission Failed",
      message: `${error.message}\n- Displays: ${displayedMessage}\n- On Address: ${propertyAddress}`,
    })
  )
}

// Placeholders for future events if needed
/* export const rehabSOWScrolled = (
  scrolledTo: number,
  type: "click" | "swipe"
) => {
  track(
    createListScrolledEvent({
      current_screen: "Rehab Estimator",
      list_type: "rehab category list",
      scrolled_to: scrolledTo,
      interaction_type: type,
    })
  )
} */

/* export const rehabHelpCTAViewed = () => {
  track(
    createComponentViewedEvent({
      current_screen: "Rehab SOW",
      component_type: "banner",
      component_function: "help cta",
      component_text: "Need help with your rehab estimate?",
    })
  )
}

export const rehabHelpCTAClicked = () => {
  track(
    createComponentClickedEvent({
      current_screen: "Rehab SOW",
      to_screen: "Help Page",
      component_type: "button",
      component_function: "navigate to help",
      component_text: "Get Help",
    })
  )
} */
